import { useMemo, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';
import rtlPlugin from 'stylis-plugin-rtl';
import { useTranslation } from 'react-i18next';
import { getTheme } from './theme';
import Navbar from './components/Navbar';
import ChoicePage from './pages/Choice';
import RegisterPage from './pages/Register';
import SearchPage from './pages/Search';
import AdminPage from './pages/Admin';

// Emotion caches — RTL uses stylis-plugin-rtl, LTR is plain
const rtlCache = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const ltrCache = createCache({ key: 'muiltr' });

export default function App() {
  const { i18n } = useTranslation();
  const dir = i18n.language === 'ar' ? 'rtl' : 'ltr';

  // Keep <html> direction in sync with selected language
  useEffect(() => {
    document.documentElement.dir = dir;
    document.documentElement.lang = i18n.language;
  }, [dir, i18n.language]);

  const theme = useMemo(() => getTheme(dir), [dir]);
  const cache = dir === 'rtl' ? rtlCache : ltrCache;

  return (
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <BrowserRouter>
          <Navbar />
          <Routes>
            <Route path="/" element={<ChoicePage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/search" element={<SearchPage />} />
            <Route path="/admin" element={<AdminPage />} />
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </CacheProvider>
  );
}
